import {action, observable} from 'mobx';
import { priceTypes } from '../buyDevice';
import { scenesType, regionType, vasType } from '@/types/APITypes';

/* 增值服务一键新机数据类型 */
export interface vasNewDeviceType {
    id: number;
    productType: priceTypes;
    productId: vasType;
    scenes: scenesType;
    region: regionType;
    title: string;
    subTitle: string;
    subscript: string;
    buyButton: string;
    officialPrice: number;
    realPrice: number;
    period: number;
    beginTime: number;
    endTime: number;
    priority: number;
    status: number;
    createTime: string;
    updateTime: string;
}

class BuyVasNewDeviceStore {
  
  @observable vasNewDeviceList: vasNewDeviceType [] = []
  
  
  @action.bound async getVasNewDeviceList () {
  
  }
  
}

export default BuyVasNewDeviceStore;
